import React from "react";
import { Row, Col, Card } from "antd";
import "./WhoUsesAll3D.scss";
import { users } from "../../data/data";

const WhoUsesAll3D = () => {
  return (
    <section className="who-uses-all3d">
      <div className="container">
        <div className="header">
          <span className="subtitle manrope f-16 w-700 lh-24">Who Uses ALL3D</span>
          <span className="title manrope f-30 w-600 lh-40">For sellers of products or spaces, large or small</span>
        </div>
        <Row gutter={[24, 24]}>
          {users.map((user, index) => (
            <Col xs={24} md={12} lg={8} key={index}>
              <Card className="user-card" bordered={false}>
                <div className="icon-wrapper">
                  <img src={user.icon} alt={`${user.title} icon`} />
                </div>
                <div className="user-card-title manrope f-20 w-700 lh-28 mb-8">{user.title}</div>
                <p className=" manrope f-16 w-400 lh-24">{user.description}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default WhoUsesAll3D;
